(() => {
  const opening = document.getElementById('oka-daily-cover');
  if (!opening || location.hostname === 'business.okaoka.store') return;
  document.documentElement.classList.add('oka-daily-in-view');
  const data = JSON.parse(document.getElementById('oka-daily-data').textContent);
  const panel = document.getElementById('oka-daily-recipe');
  const how = document.getElementById('oka-daily-how');
  const photo = opening.querySelector('.oka-daily__photo');
  const image = photo.querySelector('img');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const recipes = [
    {
      title: ['药膳鸡腿。', '今晚，配面线。'],
      name: '药膳鸡腿 · 客家黄酒面线',
      description: ['一包主菜，变成两碗暖汤面。', '面线、青菜，加一点客家黄酒。'],
      ingredients: '药膳鸡腿1包 / 面线约80g / 青菜约200g / 枸杞1–2大匙 / 客家黄酒1–2大匙，可省略',
      facts: '约18分钟 · 2人分享',
      steps: ['主菜按包装说明复热。', '煮面线，最后加入青菜。', '鸡腿与汤分到两碗。', '添枸杞，黄酒可省略。'],
      note: '食用示意 · 面线、青菜及配料需自备'
    },
    {
      title: ['照烧鸡腿。', '今晚，配意面。'],
      name: '照烧鸡腿 · 肉酱螺旋意面',
      description: ['鸡腿复热时，煮一锅螺旋意面。', '拌上肉酱，撒一点芝士。'],
      ingredients: '照烧全鸡腿1只 / 熟螺旋意面约190g / 番茄肉酱1份 / 少量芝士 / 可自配蔬菜',
      facts: '约15分钟 · 1人份',
      steps: ['鸡腿解冻后按包装复热。', '同时煮意面，留点煮面水。', '热肉酱，拌入意面。', '装盘放鸡腿，撒少量芝士。'],
      note: '食用示意 · 意面、肉酱、芝士及配菜需自备'
    }
  ];
  const localDate = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kuala_Lumpur', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  const select = date => {
    const [year, month, day] = date.split('-').map(Number);
    return ((Math.floor(Date.UTC(year, month - 1, day) / 86400000) - 20740) % recipes.length + recipes.length) % recipes.length;
  };
  let current = Number(opening.dataset.dailyIndex) || 0;
  let lastDate = localDate();
  function setLines(element, lines) {
    element.replaceChildren(document.createTextNode(lines[0]), document.createElement('br'), document.createTextNode(lines[1]));
  }
  function applyDate() {
    current = select(localDate());
    const recipe = recipes[current];
    setLines(opening.querySelector('h1'), recipe.title);
    setLines(opening.querySelector('.oka-daily__description'), recipe.description);
    const date = localDate();
    opening.querySelector('.oka-daily__label').textContent = data.today + ' · ' + Number(date.slice(5, 7)) + '月' + Number(date.slice(8)) + '日';
    opening.querySelector('.oka-daily__note').textContent = recipe.note;
    image.src = data.images[current];
    image.alt = recipe.name;
    document.getElementById('oka-daily-buy').href = data.products[current];
    opening.dataset.dailyIndex = String(current);
    opening.dataset.dailyDate = date;
    if (!panel.hidden) fillRecipe();
  }
  function fillRecipe() {
    const recipe = recipes[current];
    document.getElementById('floating-title').textContent = recipe.name;
    document.getElementById('floating-facts').textContent = recipe.facts;
    document.getElementById('floating-ingredients').textContent = recipe.ingredients;
    document.getElementById('floating-steps').replaceChildren(...recipe.steps.map(text => {
      const li = document.createElement('li');
      li.textContent = text;
      return li;
    }));
    document.getElementById('floating-buy').href = data.products[current];
    document.getElementById('floating-full').href = data.articles[current];
  }
  function closePanel(focus = true) {
    panel.hidden = true;
    opening.classList.remove('recipe-is-open');
    how.setAttribute('aria-expanded', 'false');
    if (focus) how.focus({ preventScroll: true });
  }
  how.addEventListener('click', () => {
    if (!panel.hidden) return closePanel();
    fillRecipe();
    panel.hidden = false;
    opening.classList.add('recipe-is-open');
    how.setAttribute('aria-expanded', 'true');
    panel.focus({ preventScroll: true });
  });
  panel.querySelector('.daily-panel-close').addEventListener('click', () => closePanel());
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) closePanel();
  });
  function installNavigation() {
    const oldHero = document.querySelector('.oka-home-refresh__hero');
    if (oldHero) oldHero.remove();
    const picker = document.querySelector('.oka-category-picker');
    if (!picker) return false;
    let navigation = document.querySelector('.daily-store-navigation');
    if (!navigation) {
      navigation = document.createElement('div');
      navigation.className = 'daily-store-navigation';
      document.querySelectorAll('.shopify-section-group-header-group').forEach(header => navigation.append(header));
      navigation.append(picker);
      opening.after(navigation);
    }
    let transitioning = false;
    let intent = 0;
    const handoff = () => {
      if (transitioning || !panel.hidden) return;
      transitioning = true;
      navigation.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
      setTimeout(() => { transitioning = false; }, 900);
    };
    opening.addEventListener('wheel', event => {
      if (event.deltaY <= 0 || scrollY > opening.offsetHeight - 100 || !panel.hidden) return;
      intent += event.deltaY;
      if (intent > 35) {
        event.preventDefault();
        handoff();
        intent = 0;
      }
    }, { passive: false });
    let touchY = null;
    opening.addEventListener('touchstart', event => { touchY = event.touches[0].clientY; }, { passive: true });
    opening.addEventListener('touchend', event => {
      if (touchY !== null && touchY - event.changedTouches[0].clientY > 65 && panel.hidden) handoff();
      touchY = null;
    }, { passive: true });
    new IntersectionObserver(entries => {
      document.documentElement.classList.toggle('oka-daily-in-view', entries[0].isIntersecting);
      if (!entries[0].isIntersecting) closePanel(false);
    }, { threshold: 0 }).observe(opening);
    return true;
  }
  applyDate();
  if (!installNavigation()) {
    const observer = new MutationObserver(() => { if (installNavigation()) observer.disconnect(); });
    observer.observe(document.getElementById('MainContent'), { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  }
  const gameLinks = document.querySelectorAll('[data-oka-choice-slide] a[href*="/pages/masak"]');
  gameLinks.forEach(link => link.addEventListener('click', async event => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    let gameSection = document.getElementById('oka-daily-native-game');
    if (!gameSection) {
      gameSection = document.createElement('section');
      gameSection.id = 'oka-daily-native-game';
      gameSection.className = 'daily-native-game';
      const heading = document.createElement('h2');
      heading.textContent = data.game.title;
      const close = document.createElement('button');
      close.className = 'oka-daily__secondary';
      close.textContent = data.game.close;
      close.onclick = () => { gameSection.hidden = true; link.focus({ preventScroll: true }); link.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
      const status = document.createElement('p');
      status.setAttribute('role', 'status');
      status.textContent = data.game.loading;
      const fallback = document.createElement('a');
      fallback.href = link.href;
      fallback.textContent = data.game.full;
      gameSection.append(heading, close, status, fallback);
      link.closest('[data-oka-choice-carousel]').after(gameSection);
      try {
        const response = await fetch(link.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Game unavailable');
        const source = new DOMParser().parseFromString(await response.text(), 'text/html');
        const original = source.querySelector('masak-boleh-game');
        const originalScript = source.querySelector('script[src*="masak-boleh-game.js"]');
        if (!original || !originalScript) throw new Error('Game unavailable');
        const game = document.importNode(original, true);
        gameSection.insertBefore(game, fallback);
        if (!customElements.get('masak-boleh-game')) {
          await new Promise((resolve, reject) => {
            const script = document.createElement('script');
            const url = new URL(originalScript.getAttribute('src'), link.href);
            if (url.origin !== location.origin) { reject(new Error('Invalid game origin')); return; }
            script.src = url.href;
            script.onload = resolve;
            script.onerror = reject;
            document.head.append(script);
          });
        }
        game.shadowRoot.addEventListener('click', event => {
          const anchor = event.composedPath().find(node => node.tagName === 'A');
          if (anchor && anchor.href) {
            anchor.target = '_blank';
            anchor.rel = 'noopener';
          }
        }, true);
        status.remove();
      } catch (error) {
        status.textContent = data.game.error;
      }
    }
    gameSection.hidden = false;
    gameSection.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
  }));
  let cueFrame = null;
  let cueTimer = null;
  let cueCount = 0;
  let userInteracted = false;
  let cueActive = false;
  opening.dataset.scrollCue = 'pending';
  const cueEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
  function removeCueListeners() {
    cueEvents.forEach(type => window.removeEventListener(type, cancelCue, true));
    document.removeEventListener('visibilitychange', cancelHiddenCue);
  }
  function cancelCue() {
    userInteracted = true;
    if (cueFrame !== null) cancelAnimationFrame(cueFrame);
    if (cueTimer !== null) clearTimeout(cueTimer);
    cueActive = false;
    opening.dataset.scrollCue = 'cancelled';
    removeCueListeners();
  }
  function cancelHiddenCue() {
    if (document.hidden && cueActive) cancelCue();
  }
  cueEvents.forEach(type => window.addEventListener(type, cancelCue, { passive: true, capture: true }));
  document.addEventListener('visibilitychange', cancelHiddenCue);
  function showScrollCue() {
    if (userInteracted || reduced.matches || document.hidden || scrollY > 2 || !panel.hidden) {
      opening.dataset.scrollCue = 'skipped';
      removeCueListeners();
      return;
    }
    cueActive = true;
    opening.dataset.scrollCue = 'playing';
    cueCount += 1;
    opening.dataset.scrollCueCount = String(cueCount);
    const height = Math.min(48, Math.round(innerHeight * 0.06));
    const duration = 1450;
    const started = performance.now();
    const frame = now => {
      if (userInteracted || reduced.matches || document.hidden) { cancelCue(); return; }
      const progress = Math.min(1, (now - started) / duration);
      const phase = progress < 0.65 ? progress / 0.65 : (progress - 0.65) / 0.35;
      const amplitude = progress < 0.65 ? height : height * 0.23;
      const offset = Math.pow(Math.sin(Math.PI * phase), 2) * amplitude;
      window.scrollTo({ top: progress === 1 ? 0 : offset, behavior: 'instant' });
      if (progress < 1) cueFrame = requestAnimationFrame(frame);
      else {
        cueFrame = null;
        cueActive = false;
        if (cueCount < 2) {
          opening.dataset.scrollCue = 'waiting-repeat';
          cueTimer = setTimeout(showScrollCue, 3200);
        } else {
          opening.dataset.scrollCue = 'done';
          removeCueListeners();
        }
      }
    };
    cueFrame = requestAnimationFrame(frame);
  }
  let entrance = [];
  async function playEntrance() {
    try { await image.decode(); } catch (error) {}
    if (document.hidden) await new Promise(resolve => {
      const visible = () => {
        if (!document.hidden) {
          document.removeEventListener('visibilitychange', visible);
          resolve();
        }
      };
      document.addEventListener('visibilitychange', visible);
    });
    opening.classList.add('cover-entered');
    if (reduced.matches) { opening.dataset.scrollCue = 'skipped'; removeCueListeners(); return; }
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    entrance.push(photo.animate([
      { opacity: 0.3, transform: 'scale(1) rotate(-.6deg)' },
      { opacity: 1, transform: 'scale(1.012) rotate(-.35deg)', offset: 0.28 },
      { opacity: 1, transform: 'scale(1.045) rotate(0deg)' }
    ], { duration: 4800, easing: 'cubic-bezier(.2,.55,.3,1)', fill: 'both' }));
    [...opening.querySelector('.oka-daily__copy').children].forEach((element, index) => {
      entrance.push(element.animate([{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }], {
        duration: 950, delay: 250 + index * 140, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both'
      }));
    });
    await Promise.allSettled(entrance.map(animation => animation.finished));
    setTimeout(showScrollCue, 450);
  }
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      cancelCue();
      entrance.forEach(animation => animation.cancel());
      entrance = [];
    }
  });
  playEntrance();
  const refreshDate = () => {
    if (!document.hidden && lastDate !== localDate()) {
      lastDate = localDate();
      applyDate();
    }
  };
  setInterval(refreshDate, 60000);
  document.addEventListener('visibilitychange', refreshDate);
})();
